<template>
	<div>
		<svg
			:width="iconSize"
			:height="iconSize"
			viewBox="0 0 25 25"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M12.5352 3.74512L12.5713 3.7666L12.5801 3.77539L21.6924 13.9805C21.7221 14.0137 21.7279 14.0607 21.71 14.0986L21.6836 14.1328C21.6639 14.1502 21.6386 14.1602 21.6123 14.1602L17.3809 14.1592H16.6016V21.1533L16.5928 21.1953C16.5763 21.2337 16.5385 21.2607 16.4941 21.2607H8.50586C8.44651 21.2607 8.39853 21.2127 8.39844 21.1533L8.39746 14.9395V14.1592H7.61816L3.3877 14.1602L3.3457 14.1514C3.30721 14.135 3.28038 14.0972 3.28027 14.0527C3.28027 14.0394 3.28237 14.0259 3.28711 14.0137L3.30762 13.9805L12.4199 3.77539C12.4497 3.74202 12.4954 3.73135 12.5352 3.74512Z"
				:stroke="color"
				stroke-width="1.56"
			/>
		</svg>
	</div>
</template>

<script>
export default {
	name: 'IconSvgArrowUp',
	props: {
		color: {
			type: String,
			default: '#000000',
		},
		size: {
			type: Number,
			default: null,
		},
	},
	computed: {
		iconSize() {
			return this.size ? `${this.size}px` : '44px'
		},
	},
}
</script>

<style scoped></style>
